function initSluzby(userData, isPublic) {
    if (!isPublic) {
        window.fetchRozpracovane(userData);
    }
}

export { initSluzby };